<script>
    import moment from 'moment'
    import { VueTelInput } from 'vue-tel-input'
    import PartecipantBirthdayInput from '../purchases/PartecipantBirthdayInput'
    import {Form} from '../../helpers/Form/Form'
    import {Gtag} from '../../mixins/ga'

    moment.locale('it');

    export default {
        mixins: [Gtag],
        components: {
            VueTelInput,
            PartecipantBirthdayInput
        },
        props: {
            destination: String,
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                price: this.data.price,
                loading: false,
                sportsman_name_placeholder: "Nome*",
                sportsman_last_name_placeholder: "Cognome*",
                form: new Form({
                    membership_fee: this.data.membership_fee,
                    price: this.data.price,
                    is_under: false,
                    its_me: true,
                    accept_promotion: false,
                    is_only_validate: false,
                    responsible_terms: false,
                    reservation: {
                        is_membership: null,
                        time: null,
                        datetime: ``,
                        course_id: this.data.course_id,
                        is_trial_lesson: this.data.is_trial_lesson,
                        buyable_type: null,
                        buyable_id: null
                    },
                    sportsman: {
                        birthday: this.data.user ? this.data.user.birthday: null,
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone_number: '',
                        fiscal_code: null,
                    },
                    responsible: {
                        first_name: null,
                        last_name: null,
                        email: null,
                        birthday: null,
                        fiscal_code: null,
                        phone_number: null,
                    }
                })
            }
        },
        computed: { 
            inputClasses() {
                if (this.form.errors.has('sportsman.phone_number')) {
                    return ['form-control', 'form-control-phone', 'is-invalid']
                }
                return ['form-control', 'form-control-phone']
            },
            isMobile() {
                return window.isMobile()
            },
            responsibleMaxYear() {
                let now = moment()
                return now.year() - 18
            },               
            filledForm() {
                let {sportsman, responsible} = this.form
                let emptyForm = _.isEmpty(sportsman.first_name) || _.isEmpty(sportsman.last_name) || _.isEmpty(sportsman.birthday)

                if (this.isUnder) {
                    emptyForm = _.isEmpty(sportsman.first_name) || _.isEmpty(sportsman.last_name) || _.isEmpty(sportsman.birthday)
                        || _.isEmpty(responsible.first_name) || _.isEmpty(responsible.last_name)
                        || _.isEmpty(responsible.email) || _.isEmpty(responsible.fiscal_code) || _.isEmpty(sportsman.fiscal_code)          
                }

                if (this.isUnder) {
                    return !emptyForm && this.form.responsible_terms && !_.isNull(this.form.reservation.is_membership)
                }
                return !emptyForm && !_.isNull(this.form.reservation.is_membership)
            },
            reservationTotal() {
                if (this.data.is_trial_lesson) {
                    return this.form.price + this.form.membership_fee
                }
                return 0
            }          
        },
        watch: {
            isUnder(val) {
                if (!val) {
                    this.$set(this.form.responsible, 'first_name', null)
                    this.$set(this.form.responsible, 'last_name', null)
                    this.$set(this.form.responsible, 'email', null)
                    this.$set(this.form.responsible, 'phone_number', null)
                    this.$set(this.form.responsible, 'fiscal_code', null)
                    this.$set(this.form.responsible, 'birthday', null)
                }                   
            },
            'form.its_me': {
                handler(val) {
                    if(this.data.user){
                        this.$set(this.form.sportsman, 'first_name', this.data.user.first_name)
                        this.$set(this.form.sportsman, 'last_name', this.data.user.last_name)
                        this.$set(this.form.sportsman, 'email', this.data.user.email)
                        if (val) {
                            this.$set(this, 'sportsman_name_placeholder', 'Nome*')
                            this.$set(this, 'sportsman_last_name_placeholder', 'Cognome*')
                        } else {
                            this.$set(this.form.sportsman, 'first_name', null)
                            this.$set(this.form.sportsman, 'last_name', null)
                        }
                    } else {
                        this.$set(this.form.sportsman, 'first_name', null)
                        this.$set(this.form.sportsman, 'last_name', null)
                        this.$set(this.form.sportsman, 'email', null)
                        this.$set(this, 'sportsman_name_placeholder', 'Nome del partecipante*')
                        this.$set(this, 'sportsman_last_name_placeholder', 'Cognome del partecipante*')
                    }                    
                }
            },
            'form.sportsman.birthday': {
                handler(val) {
                    let isUnder = false
                    if (!_.isEmpty(val)) {
                        let now = moment()
                        let current = moment(val)

                        isUnder = now.diff(current, 'years') < 18
                    }

                    this.$set(this.form, 'is_under', isUnder)
                }
            },
            'form.reservation.is_membership': {
                handler(val) {
                    if (this.data.hasOwnProperty('company_fee_id')) {
                        if (!val) {
                            this.$set(this.form, 'price', this.price)
                            this.$set(this.form, 'membership_fee', this.data.membership_fee)
                        } else {
                            if (this.form.price > 0) {
                                this.$set(this.form, 'price', this.price)
                                this.$set(this.form, 'membership_fee', 0)
                            } else {
                                this.$set(this.form, 'price', 0)
                                this.$set(this.form, 'membership_fee', 0)
                            }
                        }
                    } else {
                        if (this.data.membership_fee > 0) {
                            if (!val) {
                                this.$set(this.form, 'price', this.price)
                                this.$set(this.form, 'membership_fee', this.data.membership_fee)
                            } else {
                                if (this.form.price > 0) {
                                    this.$set(this.form, 'price', this.price)
                                    this.$set(this.form, 'membership_fee', 0)
                                } else {
                                    this.$set(this.form, 'price', 0)
                                    this.$set(this.form, 'membership_fee', 0)
                                }
                            }
                        }
                    }
                }
            }
        },
        mounted() {
            this.data.reservation_date.split('/')
            let times = this.data.reservation_time.split(' - ');
            this.$set(this.form.reservation, 'time', this.data.reservation_time)
            this.$set(this.form.reservation, 'datetime', `${this.data.reservation_date} ${times[0]}:00`)
            this.$set(this.form.reservation, 'is_membership', !this.data.is_trial_lesson ? 1 : 0)

            if (this.data.user) {
                this.$set(this.form, 'sportsman', {
                    first_name: this.data.user.first_name,
                    last_name: this.data.user.last_name,
                    email: this.data.user.email,
                    birthday: this.data.user.birthday,
                    phone_number: null,
                    fiscal_code: null
                })
            }
            if (this.data.is_trial_lesson) {
                this.$set(this.form, 'price', this.data.price)
                this.$set(this, 'price', this.data.price) 
            } else {
                this.$set(this.form, 'price', 0)
                this.$set(this, 'price', 0)          
                this.$set(this.form, 'membership_fee', 0)                    
            }

            this.initBuyablesSelect2()
        },
        methods: {
            initBuyablesSelect2() {
                let vm = this

                $(this.$refs.buyables).select2({
                    ajax: {
                        dataType: 'json',
                        url: route('course.buyables', this.data.course_id),
                        delay: 500,
                        data: function (params) {
                            return {
                                buyable: params.term
                            }
                        },
                        processResults: function (data) {
                            var results = [];
                            var user_subscriptions = data.user_subscriptions

                            if (user_subscriptions.length > 0) {
                                data.lesson_packages.forEach(i => {
                                    let selected = {}
                                    let idx = user_subscriptions.findIndex(us => {
                                        return us.product.buyable_type == i.class_name &&
                                            us.product.buyable_id == i.id
                                    })

                                    if (idx >= 0) {
                                        selected = user_subscriptions[idx]
                                        if (selected.can_be_selected) {
                                            results.push({
                                                id: `${i.class_name}-${i.id}`,
                                                text: i.custom_full_name_formula,                                       
                                            })
                                        }
                                    } else {
                                        results.push({
                                            id: `${i.class_name}-${i.id}`,
                                            text: i.custom_full_name_formula,                                       
                                        })                                        
                                    }                                    
                                })
                            } else {
                                data.lesson_packages.forEach(i => {
                                    results.push({
                                        id: `${i.class_name}-${i.id}`,
                                        text: i.custom_full_name_formula,                                       
                                    })
                                })
                            }

                            if (user_subscriptions.length > 0) {
                                data.course_subscriptions.forEach(i => {
                                    let selected = {}
                                    let idx = user_subscriptions.findIndex(us => {
                                        return us.product.buyable_type == i.class_name &&
                                            us.product.buyable_id == i.id
                                    })

                                    if (idx >= 0) {
                                        selected = user_subscriptions[idx]
                                        if (selected.can_be_selected) {
                                            results.push({
                                                id: `${i.class_name}-${i.id}`,
                                                text: i.custom_full_name_formula,                                       
                                            })
                                        }
                                    } else {
                                        results.push({
                                            id: `${i.class_name}-${i.id}`,
                                            text: i.custom_full_name_formula,                                       
                                        })                                        
                                    }
                                })      
                            } else {
                                data.course_subscriptions.forEach(i => {
                                    results.push({
                                        id: `${i.class_name}-${i.id}`,
                                        text: i.custom_full_name_formula,                                       
                                    })
                                })
                            }               

                            return { results };
                        }
                    }               
                }).on('change', function (event) {
                    let selected = $(this).select2('data')[0];

                    if (_.isObject(selected)) {
                        let splitData = selected.id.split('-')
                        vm.$set(vm.form.reservation, 'buyable_id', parseInt(splitData[1]))
                        vm.$set(vm.form.reservation, 'buyable_type', splitData[0])
                    }
                })   
            },
            setPartecipantType(type) {
                this.$set(this.form, 'its_me', type)
            },            
            onSubmit() {
                $("#submitRegistration").attr("disabled", true);
                $(".myCog").css("display","inline-block");
                this.loading = true;
                this.form.is_only_validate = false

                this.sendReservationGaEvent(this.form)            

                this.form
                    .submit('post', route('reservations.store'))
                    .then(response => {
                        if (response.hasOwnProperty('redirect')) {
                            location.href = response.redirect
                        } else {
                            location.href = route('reservations.thanks_reservation')
                        }
                    }).catch((error) => {
                        $("#submitRegistration").attr("disabled", false);
                        $(".myCog").css("display","none")
                        window.alerts.error('Si è verificato un errore durante la validazione')
                    });
            },
            onSubmitWithPayment() {
                this.form.is_only_validate = true
                const self = this
                this.form
                    .submit('post', this.source)
                    .then(({reservation}) => {
                        //location.href = route('reservations.payment', reservation.id)
                    }).catch((error) => {
                        $("#submitRegistration").attr("disabled", false);
                        $(".myCog").css("display","none")
                        window.alerts.error('Si è verificato un errore durante la validazione')
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationRegister.vue